import React from 'react';

export default function RPTApiNotice() {
  return (
    <div className="alert alert-info" role="alert">
      RPTAX API Settings is currently loaded.
    </div>
  );
}
